// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"da6de618","488":"9f87ffdd","977":"bd8952d9"}[chunkId] + ".chunk.js";
};